export function trimARI(ari: string): string {
	return ari.split('/').pop() || '';
}
